import apiClient from '../apiClient';

class MetadataService {
  /**
   * Get a single metadata entry by key
   * @param {string} key - e.g. WHATSAPP_GROUP_INVITE_URL
   */
  async getByKey(key) {
    return apiClient.get(`/metadata/key/${encodeURIComponent(key)}`);
  }

  /**
   * Get all metadata entries belonging to a group
   * @param {string} group - e.g. LABOURANDO_GROUP_INVITATION
   */
  async getByGroup(group) {
    return apiClient.get(`/metadata/group/${encodeURIComponent(group)}`);
  }
}

const metadataService = new MetadataService();
export default metadataService;
